import { render } from "./ImageClipHandler.vue?vue&type=template&id=1d9b5032&scoped=true&ts=true"
import script from "./ImageClipHandler.vue?vue&type=script&lang=ts"
export * from "./ImageClipHandler.vue?vue&type=script&lang=ts"

import "./ImageClipHandler.vue?vue&type=style&index=0&id=1d9b5032&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d9b5032"]])

export default __exports__